'use strict';

import Loading from '../components/Loading';
import FormAgreement from "../components/FormAgreement";

const FormInput =  React.lazy(() => import( /* webpackChunkName: "FormInput" */ '../components/FormInput'));
const PhoneInput =  React.lazy(() => import( /* webpackChunkName: "PhoneInput" */ '../components/PhoneInput'));

class RequestFormModal extends React.Component {
    constructor(props) {
        super(props);

        this.initState = {
            mode: 'form',
            prevMode: null,

            phone: '+7',
            phoneCode: 'RU',
            phoneComplete: false,
            
            name: '',
            email: '',
            comment: '',
            agreeCb: false,

            type: '',
            city: '',
            direction: '',
            date: '',
            price: '',


            errors: {},
            message: '',
            isFetching: false,
            
            goal: '',
        }
        this.state = this.initState;
        this.handleSendRequest = this.handleSendRequest.bind(this)
    }

    componentDidMount() {
        const that = this;
        $(document).on('afterShow.fb', function( e, instance ) {
            if (instance.current.src === '#reactRequestFormModal') {
                const data = instance.current.modal_data || {}
                that.setState({
                    ...that.initState,
                    ...data,
                    phone: that.state.phone,
                    phoneCode: that.state.phoneCode,
                    phoneComplete: that.state.phoneComplete,
                    name: that.state.name,
                    email: that.state.email,
                })
            }
        });
        $(document).on('afterClose.fb', function( e, instance ) {
            if (instance.current.src === '#reactRequestFormModal') {
                that.setState({ 
                    ...that.initState,
                    phone: that.state.phone,
                    phoneCode: that.state.phoneCode,
                    phoneComplete: that.state.phoneComplete,
                    name: that.state.name,
                    email: that.state.email,
                })
            }
        });
    }

    setFetching(isFetching) {
        this.setState({isFetching});
    }

    clearErrors() {
        this.setState({errors: {}});
    }

    handleSendRequest() {
        const {agreeCb, phone, phoneCode, name, email, comment} = this.state;
        const {type, city, direction, date, price} = this.state;
        const {goal} = this.state;
        
        this.setFetching(true);
        this.clearErrors();
        
        if (!agreeCb) {
            this.setState({
                message: tMsg('Необходимо согласиться с условиями'),
            });
            this.setFetching(false);
            return;
        }
        
        requestFormAction.sendRequest({phone, phoneCode, name, email, comment, type, city, direction, date, price}).then(response => {
            this.setFetching(false);
            if(response.success) {
                this.setState({
                    prevMode: 'form',
                    mode: 'success',
                })
                if (goal)
                    ymReachGoal(goal)
            } else {
                this.setState({
                    message: response.message || '',
                    errors: response.errors || {},
                });
            }
        })
    }

    render() {
        const {mode, message, errors, isFetching} = this.state;
        const {email, name, contact, agreeCb} = this.state;
        const {phone, phoneCode} = this.state;
        
        if(mode === 'form') return <div>
            <div className="reg-modal__title">
                {tMsg('Ваша заявка')}
            </div>
            <div className="reg-modal__row">
                <React.Suspense>
                    <PhoneInput
                        className={'reg-input'}
                        label={tMsg('Номер телефона')}
                        value={phone}
                        phoneCode={phoneCode}
                        error={errors.phone}
                        onChange={phone => this.setState({phone})}
                        onCodeChange={phoneCode => this.setState({phoneCode})}
                        onCompleteChange={phoneComplete => this.setState({phoneComplete})}
                    />
                </React.Suspense>
            </div>
            <div className="reg-modal__row">
                <React.Suspense>
                    <FormInput
                        className={'reg-input'}
                        label={tMsg('Имя') + ' *'}
                        value={name}
                        error={errors.name}
                        onChange={name => this.setState({name})}
                    />
                </React.Suspense>
            </div>
            <div className="reg-modal__row">
                <React.Suspense>
                    <FormInput
                        className={'reg-input'}
                        label={tMsg('Email') + ' *'}
                        value={email}
                        error={errors.email}
                        onChange={email => this.setState({email})}
                    />
                </React.Suspense>
            </div>
            <div className="reg-modal__row">
                <React.Suspense>
                    <FormInput
                        type='textarea'
                        className={'reg-input'}
                        label={tMsg('Комментарий')}
                        value={contact}
                        multiLine={true}
                        onChange={comment => this.setState({comment})}
                    />
                </React.Suspense>
            </div>

            {Object.keys(errors).length === 0 && message && <div className='error-message'>{message}</div>}
            
            <div className="reg-checkbox">
                <React.Suspense>
                    <FormAgreement
                        showCheckboxMedia={false}
                        agreeConditionsValue={agreeCb}
                        onAgreeConditionsChange={agreeCb => this.setState({agreeCb})}
                    />
                </React.Suspense>
            </div>
            <div className="reg-modal__btns">
                <button className={clsx('button button-round', {disabled: !agreeCb})} onClick={this.handleSendRequest}>
                    {tMsg('Отправить заявку')}
                </button>
            </div>
            <Loading active={isFetching}/>
        </div>

        if(mode === 'success') return <div>
            <div className="reg-modal__title" style={{marginBottom: 0}}>
                {tMsg('Ваша заявка отправлена!')}
            </div>
            <div className="reg-modal__img">
                <img src={`${themeDir}/images/reg-img.jpg`} alt=""/>
            </div>
            <Loading active={isFetching}/>
        </div>

        return null;
    }
}

const domContainer = document.querySelector('#reactRequestFormModal');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(RequestFormModal));
